import React from 'react';
import { RED, INK, GREY, BORDER } from '../seo/SeoUI';

// Soft-conversion capture: plain HTML form POST to /guides/subscribe (server-rendered
// confirmation page, no client JS needed). The reader gets the article by email; the
// address lands in the admin inbox as a warm lead. Angi-style research-phase capture.

function EmailCaptureCard({ guideSlug, guideTitle, compact }) {
  return (
    <div style={{ borderRadius: 18, padding: compact ? '26px 26px' : '30px 32px', background: 'linear-gradient(135deg, #FFF6F0 0%, #FDEEEE 100%)', border: `1px solid ${BORDER}` }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 22, alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ flex: '1 1 320px', minWidth: 260 }}>
          <h2 style={{ fontSize: compact ? 20 : 23, fontWeight: 800, margin: '0 0 8px', color: INK }}>
            📬 {compact ? 'Get our home care guides by email' : 'Send this guide to your inbox'}
          </h2>
          <p style={{ fontSize: 14.5, color: GREY, margin: 0, lineHeight: 1.6, maxWidth: 480 }}>
            {compact
              ? 'Seasonal checklists and honest cost guides, straight from the BestHand team. No spam, unsubscribe anytime.'
              : 'We’ll email you this checklist so it’s there when you need it — plus our seasonal home care reminders. No spam, unsubscribe anytime.'}
          </p>
        </div>
        <form method="post" action="/guides/subscribe" style={{ flex: '1 1 320px', minWidth: 260, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          <input type="hidden" name="guide" value={guideSlug || ''} />
          <input type="hidden" name="guideTitle" value={guideTitle || ''} />
          <input
            type="email"
            name="email"
            required
            placeholder="you@email.com"
            aria-label="Email address"
            style={{ flex: '1 1 200px', minWidth: 180, padding: '13px 16px', borderRadius: 12, border: `1px solid ${BORDER}`, fontSize: 15, background: '#fff', color: INK, outline: 'none' }}
          />
          <button type="submit" style={{ flex: 'none', padding: '13px 24px', borderRadius: 12, background: RED, color: '#fff', fontWeight: 700, fontSize: 15, border: 'none', cursor: 'pointer' }}>
            {compact ? 'Sign me up' : 'Email me this guide'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default EmailCaptureCard;
